import PropTypes from "prop-types";
import React from "react";

function LocationMarkerIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

LocationMarkerIcon.propTypes = { size: PropTypes.number };

export default LocationMarkerIcon;
